module.exports = __webpack_public_path__ + "static/img/balzw707.e0f7a09.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/balzw707.jpg
// module id = MVPR
// module chunks = 0